// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('Button')

function Button({ forwardedRef: ref, children, ...props }) {
  const { as, ...derivedProps } = derivedButtonProps(props)
  return tag(as, {
    ref,
    ...props,
    ...derivedProps,
    className: classNames(
      props.className,
      bem.block()
    )
  },
    children
  )
}

if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')
  const morePropTypes = require('client-v2/common/utils/prop-types')

  Button.propTypes = {
    // Values
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    forwardedRef: morePropTypes.domRef,
    href: PropTypes.string,
    rel: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    // Callbacks
    onClick: PropTypes.func
  }
}

function withButton(className) {
  function WithButton(props) {
    return (
      tag(Button, {
        ...props,
        className: classNames(className, props.className)
      })
    )
  }
  WithButton.displayName = `withButton(${className})`
  WithButton.propTypes = Button.propTypes
  return WithButton
}

module.exports = Object.assign(Button, {
  withButton
})

function derivedButtonProps(props) {
  if (props.href && !props.disabled) {
    return {
      as: 'a',
      href: props.href,
      rel: props.rel,
      target: props.target
    }
  }
  return {
    as: 'button',
    type: props.type || 'button',
    disabled: !!props.disabled
  }
}
